import React from 'react';
import { Typography, Card, Form, Input, Button } from 'antd';

const { Title } = Typography;

const UserProfile: React.FC = () => {
  const onFinish = (values: any) => {
    console.log('Valori del form:', values);
    // Implementa qui la logica per aggiornare il profilo
  };

  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>Profilo Utente</Title>
      <Card>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item name="username" label="Nome Utente">
            <Input />
          </Form.Item>
          <Form.Item name="email" label="Email">
            <Input />
          </Form.Item>
          <Form.Item name="password" label="Nuova Password">
            <Input.Password />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Aggiorna Profilo
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default UserProfile;